import Grid from '@mui/material/Grid'
import WelcomeBanner from 'components/molecules/home/WelcomeBanner'
import ActivityLists from './ActivityLists'

const RaterHomeLayout = () => {
  return (
    <>
      <Grid container gap={16} paddingY={10}>
        <WelcomeBanner showUpgradeButton={true} />
        <ActivityLists />
      </Grid>
    </>
  )
}

export default RaterHomeLayout
